/**
 * Chunks propres à Georges Brassens, fusionnés dans le registre du thème parent
 * (musees-de-sete/resources/assets/scripts/core/chunks.js) via chunks.register().
 * Une clé identique à celle du parent la surcharge (ex : quote).
 */
export default {
    homepageAudio: () => import(/* webpackChunkName: "home-audio" */ './home-audio.js'),
    timelineAudio: () => import(/* webpackChunkName: "timeline-audio" */ './timeline-audio.js'),
    homepageHeader: () => import(/* webpackChunkName: "gb-homepage-header" */ './modules/homepage-header.js'),
    quote: () => import(/* webpackChunkName: "gb-quote" */ './modules/quote.js'),
};
